'use client';

import dynamic from 'next/dynamic';

export const AnimationTimelineUnsupported = dynamic(
  () => import('./AnimationTimelineUnsupported'),
  {
    ssr: true,
  }
);

export const LinkedTimelineUnsupported = dynamic(
  () => import('./LinkedTimelineUnsupported'),
  {
    ssr: true,
  }
);

export const ScrollViewProgressPercentageDemo = dynamic(
  () =>
    import(
      './ScrollViewProgressPercentageDemo/ScrollViewProgressPercentageDemo'
    ),
  {
    ssr: true,
  }
);
